import { render, staticRenderFns } from "./SearchDocument.vue?vue&type=template&id=125b8a30&"
import script from "./SearchDocument.vue?vue&type=script&lang=js&"
export * from "./SearchDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports